import React, { useEffect, useState } from 'react';
import {
  Container,
  Form,
  Row,
  Col,
  Button,
} from '@themesberg/react-bootstrap';
import { post } from '../../../services/back.service';
import useAutosave from '../../../hooks/useAutosave';

const porcentajes = [5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]

function FormInfoTiresMoto({ id }) {
  const [infoTires, setInfoTires] = useState({});
  const [msgButton, setMsgButton] = useState('Guardar Informacion')
  const [obsTires, setObsTires] = useState('');

  const autosave = useAutosave(async () => {
    await post('/peritaje/modifyinspection/tires/' + id, {
      header: { obs_tires: obsTires },
      data: infoTires
    });
  });

  const handleForm = ({ target }) => {
    const tmpinfoTires = { ...infoTires, [target.name]: target.value }
    setInfoTires(tmpinfoTires);
    autosave.schedule();
    //generalUpdate('infoTires', tmpinfoTires);
  };

  const sendInfo = async (event) => {
    event.preventDefault();
    autosave.cancel();
    const body = {
      header: { obs_tires: obsTires },
      data: infoTires
    };
    const respo = await post('/peritaje/modifyinspection/tires/' + id, body);
    if (respo.success) {
      setMsgButton('Actualizar')
    }
  };

  useEffect(() => {
    const initForm = async () => {
      const body = {};
      let tmpTires = {};
      const respo = await post('/peritaje/infodetailinspection/tires/' + id, body);
      if (respo.success) {
        const { detail, header } = respo.data;
        setObsTires(header.obs_tires)
        for (let i = 0; i < detail.length; i++) {
          const element = detail[i];
          tmpTires[element.name_tire] = element.percentage
        }
        setInfoTires(tmpTires);
      }
    };
    initForm();
  }, [id]);
  return (
    <Container>
      <Row className="mb-1">
        <Col>
          <h1 className="fw-bold">Llantas</h1>
        </Col>
      </Row>
      <hr style={{ opacity: 0.1 }} />
      <Row>
        <Col xs="6" md="6">
          <Form.Label htmlFor="llantadelantera">
            Llanta Delantera
          </Form.Label>
          <Form.Select
            name="tire_front"
            value={infoTires.tire_front}
            onChange={(e) => handleForm(e)}
          >
            <option value="0">Seleccione</option>
            {porcentajes.map((element, i) => <option key={i} value={element}>{element}</option>)}
          </Form.Select>
        </Col>
        <Col xs="6" md="6">
          <Form.Label htmlFor="traseraizquierda">Llanta Trasera</Form.Label>
          <Form.Select
            name="tire_rare"
            value={infoTires.tire_rare}
            onChange={(e) => handleForm(e)}
          >
            <option value="0">Seleccione</option>
            {porcentajes.map((element, i) => <option key={i} value={element}>{element}</option>)}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs="6" md="6">
          <Form.Label htmlFor="delanteraderecha">Rin Delantero</Form.Label>
          <Form.Select
            name="wheels_front"
            value={infoTires.wheels_front}
            onChange={(e) => handleForm(e)}
          >
            <option value="0">Seleccione</option>
            {porcentajes.map((element, i) => <option key={i} value={element}>{element}</option>)}
          </Form.Select>
        </Col>
        <Col xs="6" md="6">
          <Form.Label htmlFor="traseraderecha">Rin Trasero</Form.Label>
          <Form.Select
            name="wheels_rare"
            value={infoTires.wheels_rare}
            onChange={(e) => handleForm(e)}
          >
            <option value="0">Seleccione</option>
            {porcentajes.map((element, i) => <option key={i} value={element}>{element}</option>)}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Label htmlFor="obsTires">Observacion llantas</Form.Label>
          <Form.Control
            as="textarea"
            rows={1}
            name="obsTires"
            value={obsTires}
            onChange={(e) => { setObsTires(e.target.value); autosave.schedule(); }}
          />
        </Col>
      </Row>
      <Row className="my-3">
        <Col className="d-flex justify-content-end">
          <Button type="submit" variant="primary" onClick={sendInfo}>
            {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default FormInfoTiresMoto;
